/** Normalizes manifest SHA-256 hex (lowercase, no separators or `sha256:` prefix). */
export function normalizeSha256Hex(value: string): string | null {
  const trimmed = value.trim().toLowerCase().replace(/^sha256:/, '');
  const hex = trimmed.replace(/[^a-f0-9]/g, '');
  if (hex.length !== 64) return null;
  return hex;
}

/** Compares APK bytes with manifest SHA-256 when provided. */
export async function verifyApkSha256Hex(bytes: Uint8Array, expectedSha256: string): Promise<boolean> {
  const expected = normalizeSha256Hex(expectedSha256);
  if (!expected) return false;
  const copy = new Uint8Array(bytes.byteLength);
  copy.set(bytes);
  const digest = await crypto.subtle.digest('SHA-256', copy);
  const actual = bufferToHex(new Uint8Array(digest));
  return actual === expected;
}

function bufferToHex(bytes: Uint8Array): string {
  return [...bytes].map((b) => b.toString(16).padStart(2, '0')).join('');
}
